/**
 * Sync storefront language (ds_lang) with Shopify checkout locale.
 * Requires bg/en/nl/de to be published in Shopify Admin > Settings > Languages.
 */
(function () {
  var STORAGE_KEY = 'ds_lang';
  var SUPPORTED = ['bg', 'en', 'nl', 'de'];

  function normalizeLang(value) {
    if (!value) return 'bg';
    var lang = String(value).toLowerCase().slice(0, 2);
    return SUPPORTED.indexOf(lang) !== -1 ? lang : 'bg';
  }

  function getSavedLang() {
    return normalizeLang(localStorage.getItem(STORAGE_KEY));
  }

  function getShopifyLang() {
    var fromWindow = window.DS_SHOPIFY_LOCALE;
    if (fromWindow) return normalizeLang(fromWindow);
    return normalizeLang(document.documentElement.lang);
  }

  function withLocale(url, lang) {
    try {
      var u = new URL(url, window.location.origin);
      if (u.pathname.indexOf('/checkout') !== -1 || u.pathname.indexOf('/cart') !== -1) {
        u.searchParams.set('locale', lang);
      }
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function patchCheckoutTargets(lang) {
    document.querySelectorAll('a[href*="/checkout"], a[href*="/cart"]').forEach(function (link) {
      link.href = withLocale(link.getAttribute('href') || link.href, lang);
    });

    document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
      form.action = withLocale(form.getAttribute('action') || form.action, lang);
    });
  }

  function syncShopifyLocale(lang) {
    var body = new URLSearchParams();
    body.set('form_type', 'localization');
    body.set('utf8', '\u2713');
    body.set('_method', 'put');
    body.set('return_to', window.location.pathname + window.location.search);
    body.set('locale_code', lang);

    return fetch('/localization', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html,application/xhtml+xml',
      },
    });
  }

  function switchLanguage(lang) {
    lang = normalizeLang(lang);
    localStorage.setItem(STORAGE_KEY, lang);
    return syncShopifyLocale(lang).finally(function () {
      if (!isThemeEditor()) window.location.reload();
    });
  }

  function bindLanguageSwitcher() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('.alang-btn[data-lang]');
        if (!btn) return;
        if (!btn.closest('.lang-drop-menu') && !btn.closest('.mobile-lang-options')) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        switchLanguage(btn.getAttribute('data-lang'));
      },
      true
    );
  }

  function bindCheckoutNavigation(lang) {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="/checkout"]');
        if (!link) return;

        var target = withLocale(link.getAttribute('href') || link.href, lang);
        if (target !== link.href) {
          e.preventDefault();
          window.location.href = target;
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;

        var returnToInput = form.querySelector('input[name="return_to"]');
        if (!returnToInput) return;

        var val = returnToInput.value || '';
        if (val.indexOf('/checkout') === -1) return;

        returnToInput.value = withLocale(val, getSavedLang());
      },
      true
    );

    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        patchCheckoutTargets(getSavedLang());
      });
    });
  }

  function observeDynamicLinks(lang) {
    if (!('MutationObserver' in window)) return;

    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        patchCheckoutTargets(lang);
      }, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function isThemeEditor() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function init() {
    var saved = getSavedLang();
    var shopify = getShopifyLang();

    bindLanguageSwitcher();
    bindCheckoutNavigation(saved);
    patchCheckoutTargets(saved);
    observeDynamicLinks(saved);

    if (isThemeEditor()) return;

    if (saved !== shopify) {
      var syncKey = 'ds_locale_sync:' + saved + ':' + shopify;
      if (sessionStorage.getItem(syncKey)) return;
      sessionStorage.setItem(syncKey, '1');

      syncShopifyLocale(saved).finally(function () {
        window.location.reload();
      });
    }
  }

  window.DrStoykovCheckoutLocale = {
    getSavedLang: getSavedLang,
    withLocale: withLocale,
    syncShopifyLocale: syncShopifyLocale,
    switchLanguage: switchLanguage,
    patchCheckoutTargets: patchCheckoutTargets,
    checkoutUrl: function () {
      return withLocale('/checkout', getSavedLang());
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
